import StoryblokClient from "storyblok-js-client";
import tvgConf from "@tvg/conf";

export const startInput = (event, reactComponent) => {
  // this will alter the state and replaces the current story with a current raw story object (no resolved relations or links)
  if (event.story.content._uid === reactComponent.state.content._uid) {
    reactComponent.setState({
      content: window.storyblok.addComments(event.story.content, event.story.id)
    });
  }
};

export default class StoryblokService {
  devMode;

  token;

  client;

  state = {};

  query = {};

  constructor() {
    this.tvgConf = tvgConf();
    this.devMode = this.tvgConf.environment !== "production";
    this.token = this.tvgConf.config("storyblokToken");
    this.client = new StoryblokClient({
      accessToken: this.token,
      cache: {
        clear: "auto",
        type: "memory"
      }
    });

    this.query = {};
  }

  tvgConf;

  getCacheVersion() {
    return this.client.cacheVersion;
  }

  get(slug, params) {
    const param = params || {};

    if (this.getQuery("_storyblok") || this.devMode) {
      param.version = "draft";
    }

    if (
      typeof window !== "undefined" &&
      typeof window.StoryblokCacheVersion !== "undefined"
    ) {
      param.cv = window.StoryblokCacheVersion;
    }

    return this.client.get(slug, param);
  }

  initEditor(reactComponent) {
    if (window.storyblok) {
      window.storyblok.init({
        accessToken: this.token
      });

      window.storyblok.on(["change", "published"], () => {
        location.reload(true);
      });

      // this will alter the state and replaces the current story with a current raw story object (no resolved relations or links)
      window.storyblok.on("input", (event) => {
        startInput(event, reactComponent);
      });
    }
  }

  setQuery(query) {
    this.query = query;
  }

  getQuery(param) {
    return this.query[param];
  }

  bridge() {
    if (!this.getQuery("_storyblok") && !this.devMode) {
      return "";
    }
    return `//app.storyblok.com/f/storyblok-latest.js?t=${this.token}`;
  }

  richText(blok) {
    return this.client.richTextResolver.renderNode(blok);
  }
}
